import { Button } from "antd";
import { PureComponent, ReactNode } from "react";
import { strings } from "utils/localizedStrings";
import {
  IActionButtonState,
  IActionComponentButton,
} from "./interface/IActionButtonComponent";

export default class ActionButtonComponent extends PureComponent<
  IActionComponentButton,
  IActionButtonState
> {
  constructor(props: IActionComponentButton) {
    super(props);
    this.state = {
      buttonLoading: false,
      deleteLoading: false,
    };
  }

  render(): ReactNode {
    const { buttonProps, children } = this.props?.data;
    const { buttonLoading, deleteLoading } = this.state;
    return (
      <div className="flex justify-center items-center gap-1">
        {children ?? <></>}
        {buttonProps
          ?.filter((child) => child !== undefined)
          ?.map((item, index) => {
            return (
              <Button
                key={`${item?.label}${index}`}
                shape="round"
                disabled={
                  item?.label === strings.GlobalLabels.Deleted
                    ? deleteLoading
                    : buttonLoading
                }
                type={"link"}
                danger={
                  item?.label === strings.GlobalLabels.Deleted ? true : false
                }
                style={{
                  color: item?.colorPrimary,
                }}
                className={item?.className}
                onClick={async () => {
                  item?.label === strings.GlobalLabels.Deleted
                    ? this.setState({
                        deleteLoading: true,
                      })
                    : this.setState({
                        buttonLoading: true,
                      });
                   await (item?.onClick() as Promise<void>).finally(() => {
                    this.setState({
                      buttonLoading: false,
                      deleteLoading: false,
                    });
                  });
                }}
                icon={item?.icon}
                iconPosition="end"
              >
                {item?.label}
              </Button>
            );
          })}
      </div>
    );
  }
}
